var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullscreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.334 18.667H6.667v6.666h6.667v-2.666h-4v-4Zm-2.667-5.334h2.667v-4h4V6.667H6.667v6.666Zm16 9.334h-4v2.666h6.667v-6.666h-2.667v4Zm-4-16v2.666h4v4h2.667V6.667h-6.667Z"
})));
export default SvgFullscreen;